/* =====================================================================
   HOSPEQ UI — small helper script (2026-10-09). Loaded from layout/theme.liquid (defer).
   Collection pages: keeps three CSS variables up to date so the category title bar, the
   Filter/Sort toolbar and the filter column can stay pinned under the sticky header:
     --hq-hdr  visible height of the sticky header (it shrinks/grows as you scroll)
     --hq-ban  height of the collection title bar (section .cc-collection-banner)
     --hq-tb   height of the products toolbar (#products-toolbar)
   Used by the "Collection page" rules in assets/hq-ui.css. No other behaviour.
   ===================================================================== */
(function () {
  var root = document.documentElement;
  var ro = null;
  var watched = [];

  function h(el) { return el ? Math.round(el.getBoundingClientRect().height) : 0; }

  function update() {
    var hdr = document.querySelector('.cc-header--sticky');
    root.style.setProperty('--hq-hdr', Math.max(0, h(hdr) - 1) + 'px'); /* header sits at top:-1px */
    root.style.setProperty('--hq-ban', h(document.querySelector('.cc-collection-banner')) + 'px');
    root.style.setProperty('--hq-tb', h(document.querySelector('#products-toolbar')) + 'px');
  }

  function watch() {
    if (!ro) return;
    ['.cc-header--sticky', '.cc-collection-banner', '#products-toolbar'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && watched.indexOf(el) === -1) { ro.observe(el); watched.push(el); }
    });
  }

  function init() {
    if (!document.querySelector('.cc-collection-banner, #products-toolbar')) return;
    update();
    /* scroll/resize: the header shrinks and grows as you scroll (also covers browsers/tabs where
       ResizeObserver is paused) */
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('transitionend', update, true);
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(update);
      watch();
      /* the toolbar is re-rendered when filters change: re-attach */
      new MutationObserver(function () { watch(); update(); })
        .observe(document.getElementById('main-content') || document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* =====================================================================
   HOSPEQ UI — strict search (owner decision 2026-10-09, see log 12.17)
   Shopify's "semantic search" adds loosely related products to every search (e.g. "otoscope"
   864 results incl. stethoscopes; strict: 141). Putting each word in quotes makes Shopify match
   the words exactly (plural/singular and upper/lower case still match) and skip the extras.
   Rules:
   - A one-word search that contains a digit (a part number, e.g. 58522) is left as is, so
     partial part numbers keep working.
   - Otherwise every word is put in quotes ("littmann" "6152"); filler words are dropped.
   - If a strict search finds nothing (typo, odd spelling), the page re-runs the normal search
     once and says so (hq_loose=1 marks that run).
   - Shoppers never see the quotes: they are removed from the search boxes, heading and tab title.
   ===================================================================== */
(function () {
  var STOP = ['and', 'or', 'for', 'with', 'the', 'of', 'in', 'to', 'a', 'an', 'on', 'by'];

  function clean(q) { return (q || '').replace(/["“”]/g, ' ').replace(/\s+/g, ' ').trim(); }

  function strict(q) {
    var c = clean(q);
    if (!c) return c;
    var words = c.split(' ');
    /* HEINE part number typed with dashes (J-008-31-413, J008-31-413, 008-31-413): Shopify treats a
       dash tag as a duplicate of the dotted tag, so rewrite to the catalogue form J-008.31.413 */
    var hp = words.length === 1 && c.match(/^([A-Za-z])?-?(\d{3})-(\d{2})-(\d{3})$/);
    if (hp) return (hp[1] ? hp[1].toUpperCase() + '-' : '') + hp[2] + '.' + hp[3] + '.' + hp[4];
    if (words.length === 1 && /\d/.test(c)) return c;          /* part number: keep prefix matching */
    var out = [];
    words.forEach(function (w) {
      if (!/[a-z0-9]/i.test(w)) return;                          /* stray symbols */
      if (STOP.indexOf(w.toLowerCase()) !== -1 && words.length > 1) return;
      out.push('"' + w + '"');
    });
    return out.length ? out.join(' ') : c;
  }

  function isSearchForm(f) {
    var a = (f.getAttribute('action') || '').split('?')[0];
    return /\/search$/.test(a);
  }

  /* 1) every search form: make the words strict just before it is sent */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !isSearchForm(f)) return;
    var input = f.querySelector('input[name="q"]');
    if (!input || !clean(input.value)) return;
    input.value = strict(input.value);
    var loose = f.querySelector('input[name="hq_loose"]');
    if (loose) loose.parentNode.removeChild(loose);
  }, true);

  /* 2) on the results page */
  if (!/\/search\/?$/.test(location.pathname)) return;
  var params = new URLSearchParams(location.search);
  var q = params.get('q') || '';
  if (!clean(q)) return;
  var looseRun = params.get('hq_loose') === '1';
  if (params.get('hq_cat') === '1') return;   /* 12.55: category listing from the search drop-down, leave as is */

  /* arrived without strict words (link, voice search, typed URL): reload once with them */
  if (!looseRun && strict(q) !== q && !params.get('page')) {
    params.set('q', strict(q));
    location.replace(location.pathname + '?' + params.toString());
    return;
  }

  function tidy() {
    var shown = clean(q);
    document.querySelectorAll('input[name="q"]').forEach(function (i) {
      if (i.value && /"/.test(i.value)) { i.value = clean(i.value); i.setAttribute('value', i.value); }
    });
    document.title = document.title.replace(q, shown).replace(/""/g, '"');
    var box = document.querySelector('.hq-srch');
    if (!box) return;
    var count = parseInt(box.getAttribute('data-hq-count') || '0', 10);
    /* strict search found nothing: run the normal search once */
    if (!looseRun && count === 0 && /"/.test(q)) {
      params.set('q', shown);
      params.set('hq_loose', '1');
      location.replace(location.pathname + '?' + params.toString());
      return;
    }
    if (looseRun && count > 0 && !box.querySelector('.hq-srch__note')) {
      var p = document.createElement('p');
      p.className = 'hq-srch__note';
      var tpl = box.getAttribute('data-hq-note') || 'No exact matches for “%TERMS%” — showing the closest results.';
      p.textContent = tpl.split('%TERMS%').join(shown);
      box.querySelector('.hq-srch__head').insertAdjacentElement('afterend', p);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tidy);
  else tidy();
})();

/* ---------- Main menu balance (owner 2026-10-10, log 12.21) ----------
   Vendor Stores (first item) stays far left and Medical Specialties (last item) far right, both on
   the FIRST menu row; the product categories that fit go between them (centred), the rest wrap to
   row 2 (centred). Works only when both end items are the theme's "featured links" and on desktop.
   Uses CSS order (see hq-ui.css "menu balance"); recalculated on resize and after fonts load. */
(function () {
  var mq = window.matchMedia('(min-width: 769px)');
  function balance() {
    var ul = document.querySelector('.main-nav');
    if (!ul) return;
    var lis = [].filter.call(ul.children, function (e) { return e.tagName === 'LI'; });
    if (lis.length < 3) return;
    var first = lis[0], last = lis[lis.length - 1];
    var ok = mq.matches && first.querySelector('.main-nav__link--featured') && last.querySelector('.main-nav__link--featured');
    if (!ok) {
      lis.forEach(function (li) { li.style.order = ''; });
      ul.classList.remove('hq-nav-bal', 'hq-nav-bal--2');
      return;
    }
    if (!first.offsetWidth) return; /* menu hidden (compact header): keep the last layout */
    var cs = getComputedStyle(ul);
    var room = ul.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) - 2;
    var used = first.offsetWidth + last.offsetWidth, wrapped = false;
    first.style.order = '0';
    last.style.order = '2';
    for (var i = 1; i < lis.length - 1; i++) {
      var w = lis[i].offsetWidth;
      if (!wrapped && used + w <= room) { used += w; lis[i].style.order = '1'; }
      else { wrapped = true; lis[i].style.order = '4'; }
    }
    ul.classList.add('hq-nav-bal');
    ul.classList.toggle('hq-nav-bal--2', wrapped);
  }
  var t = null;
  function later() { clearTimeout(t); t = setTimeout(balance, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', balance);
  else balance();
  window.addEventListener('load', balance);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(balance);
})();

/* ---------- 12.44 Product page vendor logo: box sizing + trim of the transparent margin (Decision #29) ----------
   Each logo is measured once (canvas; the CDN allows it) and its box gets the visible mark's proportions,
   so wide logos (ADC, TERUMO, Medtronic) fill the 240 x 100 box (phones 160 x 60, see hq-ui.css 12.44). */
(function () {
  function trim(img) {
    var box = img.parentElement;
    if (!box) return;
    if (box.tagName !== 'A') { var s = document.createElement('span'); img.parentNode.insertBefore(s, img); s.appendChild(img); box = s; }
    box.classList.add('hq-vl');
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var w = probe.naturalWidth, h = probe.naturalHeight, c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d'); ctx.drawImage(probe, 0, 0);
        var d = ctx.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
        for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
          var i = (y * w + x) * 4;
          if (d[i + 3] > 20 && !(d[i] > 240 && d[i + 1] > 240 && d[i + 2] > 240)) {
            if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
          }
        }
        if (x1 < 0) return;
        var pad = Math.round(Math.max(x1 - x0, y1 - y0) * 0.02);
        x0 = Math.max(0, x0 - pad); y0 = Math.max(0, y0 - pad); x1 = Math.min(w - 1, x1 + pad); y1 = Math.min(h - 1, y1 + pad);
        var bw = x1 - x0 + 1, bh = y1 - y0 + 1;
        box.style.setProperty('--hq-ar', (bw / bh).toFixed(4));
        box.style.setProperty('--hq-iw', (w / bw * 100).toFixed(3) + '%');
        box.style.setProperty('--hq-ix', (-x0 / bw * 100).toFixed(3) + '%');
        box.style.setProperty('--hq-iy', (-y0 / bh * 100).toFixed(3) + '%');
        box.classList.add('is-trim');
      } catch (e) { /* no canvas access: keep the plain contain box */ }
    };
    probe.src = img.getAttribute('src');
  }
  function run() { document.querySelectorAll('.vendor-logo img.vendor-logo-img').forEach(trim); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* ---- 12.45 Compare display - Decisions #14 / #14b (2026-10-14) ----
   "Show more" under the ~4-line description in the compare popup: tap to open/close (not hover).
   The link is hidden when the description already fits. */
(function () {
  function fit() {
    document.querySelectorAll('.hq-cmp-desc').forEach(function (d) {
      var b = d.nextElementSibling;
      if (!b || !b.classList.contains('hq-cmp-more') || d.classList.contains('is-open')) return;
      if (!d.offsetParent) return;
      b.hidden = d.scrollHeight <= d.clientHeight + 2;
    });
  }
  function later() { [50, 300, 800, 1600].forEach(function (t) { setTimeout(fit, t); }); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.hq-cmp-more') : null;
    if (!b) return;
    e.preventDefault();
    var d = b.previousElementSibling;
    if (!d || !d.classList.contains('hq-cmp-desc')) return;
    var open = d.classList.toggle('is-open');
    b.textContent = open ? b.getAttribute('data-less') : b.getAttribute('data-more');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  function start() {
    var mo = new MutationObserver(later);
    document.querySelectorAll('.js-compare-area').forEach(function (a) { mo.observe(a, { childList: true }); });
    window.addEventListener('resize', fit);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* ---- 12.52 Product images: no right-click menu, no dragging (brief UI_Brief_Block_Image_RightClick_2026-10-17) ----
   Only product images: product gallery + thumbnails, zoom view, quick-add drawer, product cards (collections,
   search, home), "You may also like" / sticky cards, cart items, compare popup, product results in the search
   drop-down. Everything else (text, links, MPN/SKU, prices, menus, category tiles, banners) is untouched.
   No message is shown: the right-click simply does nothing on those images. Event delegation on document,
   so it also works on content loaded later (cart drawer, quick add, recommendations, compare).
   The phone long-press menu is stopped by CSS (-webkit-touch-callout: none, 12.52 block in hq-ui.css). */
(function () {
  var SEL = ".media-gallery img, .media-viewer img, .media-thumbs img, gallery-zoom-open img, img.zoom-image, .gallery-zoom img, .gallery-zoom-modal img, quick-add-drawer .quick-add__content img, product-card img, .card--product .card__media img, .card--related .card__media img, .cart-item__image img, [data-compare-key=\"compare-image\"] img, .predictive-search__item a[href*=\"/products/\"] img";
  function isProdImg(el) {
    return !!(el && el.tagName === 'IMG' && el.matches && el.matches(SEL));
  }
  // True when (x, y) is on the element's own text (not on an empty part of its box,
  // e.g. a card title link stretched over the whole card).
  function onOwnText(el, x, y) {
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType !== 3 || n.nodeValue.trim() === '') continue;
      var rg = document.createRange();
      rg.selectNodeContents(n);
      var rs = rg.getClientRects();
      for (var i = 0; i < rs.length; i++) {
        var r = rs[i];
        if (x >= r.left - 2 && x <= r.right + 2 && y >= r.top - 2 && y <= r.bottom + 2) return true;
      }
    }
    return false;
  }
  function under(img, x, y) {
    var r = img.getBoundingClientRect();
    return r.width > 0 && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  }
  // True when the pointer is on a product image. Some images sit under an empty overlay
  // (loading spinner, a card link stretched over the card) or ignore the pointer so the image
  // link gets the click (product cards). So: never when the pointer is on text; otherwise look
  // for a product image under the pointer, near the element clicked.
  function onProductImage(e) {
    var t = e.target;
    if (!t || t.nodeType !== 1) return false;
    if (isProdImg(t)) return true;
    if (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT|BUTTON|BODY|HTML)$/.test(t.tagName)) return false;
    var x = e.clientX, y = e.clientY;
    if (typeof x !== 'number' || (x === 0 && y === 0)) return false;
    if (onOwnText(t, x, y)) return false;
    if (document.elementsFromPoint) {
      var list = document.elementsFromPoint(x, y);
      for (var i = 0; i < list.length && i < 8; i++) {
        if (isProdImg(list[i])) return true;
      }
    }
    var el = t;
    for (var up = 0; up < 6 && el && el.tagName !== 'BODY'; up++, el = el.parentElement) {
      var imgs = el.querySelectorAll(SEL);
      if (imgs.length > 60) break;
      for (var k = 0; k < imgs.length; k++) {
        if (under(imgs[k], x, y)) return true;
      }
    }
    return false;
  }
  function mark(el) {
    if (isProdImg(el) && el.getAttribute('draggable') !== 'false') el.setAttribute('draggable', 'false');
  }
  document.addEventListener('contextmenu', function (e) {
    if (onProductImage(e)) e.preventDefault();
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (onProductImage(e)) e.preventDefault();
  }, true);
  ['mouseover', 'touchstart', 'pointerdown'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { mark(e.target); }, { capture: true, passive: true });
  });
  function markAll() { document.querySelectorAll(SEL).forEach(mark); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markAll); else markAll();
  window.addEventListener('load', markAll);
})();
/* ---- 12.54 Home "Featured Products" slider: a click with a tiny mouse movement opens the product
   (brief UI_Brief_Featured_Products_Freeze_2026-10-19) ----
   The theme slider (main.js CarouselSlider) marks itself "is-dragging" on ANY mouse movement while the button is down,
   and main.css then switches card links off (.slider.is-dragging a{pointer-events:none}), so a click with 1-3 px of hand
   movement did nothing. hq-ui.css 12.54 keeps the links on in this block; here the click is cancelled only after a real
   drag (more than 8 px), so dragging the slider still never opens a product. Only .cc-featured-collection. */
(function () {
  var LIMIT = 8, x0 = null, y0 = null;
  function inBlock(t) { return !!(t && t.closest && t.closest('.cc-featured-collection')); }
  document.addEventListener('mousedown', function (e) {
    if (e.button !== 0 || !inBlock(e.target)) { x0 = null; return; }
    x0 = e.clientX; y0 = e.clientY;
  }, true);
  document.addEventListener('click', function (e) {
    if (x0 === null || !inBlock(e.target)) return;
    var moved = Math.abs(e.clientX - x0) > LIMIT || Math.abs(e.clientY - y0) > LIMIT;
    x0 = null;
    if (moved && e.target.closest('a')) { e.preventDefault(); e.stopPropagation(); }
  }, true);
})();
/* ---- 12.55 Header search "All" category drop-down: choosing a category always does something useful
   (brief UI_Brief_Signature_Text_Search_Dropdown_2026-10-21) ----
   The theme already scopes the search to the chosen product type (hidden field filter.p.product_type, set by
   search-form.js) and the drop-down suggestions (predictive-search.js), but with an empty box choosing a category
   did nothing visible, and the animated placeholder hid the choice. Now:
   - box empty: choosing a category opens it right away: its collection page when one exists for exactly that
     product type (same handle, first product of that type), otherwise the search page limited to that type
     (all its products, with the count);
   - text typed: the search runs within that category, as before;
   - the placeholder reads "Search in <category>..." / "Buscar en <categoría>..." while a category is chosen.
   "All" / "Todos" puts everything back.
   Spanish (any non-default language): product types are translated product by product and not consistently, so
   Shopify's type filter finds 0 there. In those languages the collection page is still opened when it exists;
   otherwise, and for typed searches, the search runs without the type filter (results instead of 0).
   The English category listing uses hq_cat=1 so the strict-search rule (12.17) leaves it as it is (all products of
   the type); in other languages 12.17 makes the category words strict. */
(function () {
  var cs = document.getElementById('product_types');
  var input = document.getElementById('header-search');
  if (!cs || !input) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var es = /^es\b/i.test(document.documentElement.lang || '');
  var TPL = es ? 'Buscar en %s…' : 'Search in %s…';
  var scope = '';
  var ph0 = input.getAttribute('placeholder') || '';
  var protoSet = Element.prototype.setAttribute;
  /* the theme's typing animation keeps rewriting the placeholder: while a category is chosen, keep the scope text */
  input.setAttribute = function (n, v) {
    if (scope && String(n).toLowerCase() === 'placeholder') v = TPL.replace('%s', scope);
    return protoSet.call(this, n, v);
  };
  function handleize(s) { return s.toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function firstType(h) {
    return fetch('/collections/' + h + '/products.json?limit=1')   /* default language: product types as in the drop-down */
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return j.products && j.products[0] ? j.products[0].product_type : null; })
      .catch(function () { return null; });
  }
  function open(t) {
    var hs = [handleize(t)], h2 = handleize(t.replace(/&/g, ' and '));
    if (h2 !== hs[0]) hs.push(h2);
    var i = 0;
    (function next() {
      if (scope !== t) return;                      /* choice changed meanwhile */
      if (i >= hs.length) {
        var p = { q: t, 'options[prefix]': 'last' };
        if (root === '/') { p['filter.p.product_type'] = t; p.hq_cat = '1'; }   /* other languages: 12.17 makes the words strict */
        location.href = root + 'search?' + new URLSearchParams(p).toString();
        return;
      }
      var h = hs[i++];
      firstType(h).then(function (pt) {
        if (scope !== t) return;
        if (pt === t) location.href = root + 'collections/' + h;
        else next();
      });
    })();
  }
  var form = input.closest('form'), typeInput = document.getElementById('product_type_input');
  if (form && typeInput && root !== '/') form.addEventListener('submit', function () { typeInput.value = ''; }, true);
  cs.addEventListener('change', function (e) {
    var t = (e.detail && e.detail.selectedValue) || '';
    scope = t;
    if (root !== '/' && typeInput) typeInput.value = '';   /* other languages: no type filter (see above), also for the suggestions */
    input.setAttribute('placeholder', t ? '' : ph0);   /* with a category chosen, the wrapper above writes the scope text */
    if (t && !input.value.trim()) open(t);
  });
})();

/* ---- 12.60 Speed: mega-menu tiles and search categories on demand (brief UI_Brief_Speed_CWV_MegaMenu_LCP_2026-10-24) ----
   sections/header.liquid now leaves out of every page (data-hq-empty):
   - the L3 picture tiles of each mega-menu panel   ul.main-nav__grandchild[data-hq-l3="L1-L2"]
   - the empty-panel fallback tiles                  .hq-nav-fallback__grid[data-hq-fb="L1"]
   - the 600+ search "All" categories               custom-select#product_types (only "All" stays)
   The first time a visitor points at / focuses / taps the menu or the category box, the full header is fetched once
   from /?view=hqpanels&sections=<header id> (templates/index.hqpanels.json; header.liquid renders in full there),
   the pieces are kept in sessionStorage for the visit, and each menu panel is filled when it is opened.
   If the fetch fails the menu still works: L1/L2 links and the "Browse all … categories" links are in the page. */
(function () {
  var nav = document.querySelector('main-menu');
  var cs = document.getElementById('product_types');
  var csEmpty = !!(cs && cs.querySelector('.custom-select__listbox') && cs.closest('[data-hq-types-empty]'));
  if (!document.querySelector('main-menu [data-hq-empty]') && !csEmpty) return;
  var sec = (nav || cs).closest('.shopify-section');
  if (!sec) return;
  var sid = sec.id.replace(/^shopify-section-/, '');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'hq-mega-1260:' + ((window.Shopify && Shopify.theme && Shopify.theme.id) || '') + ':' + root + ':' + sid;
  var data = null, pending = null, wanted = [];
  try { data = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { data = null; }

  function squeeze(h) { return h.replace(/\s*\n\s*/g, ' ').trim(); }
  function load() {
    if (data) return Promise.resolve(data);
    if (pending) return pending;
    pending = fetch(root + '?view=hqpanels&sections=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('hq-mega ' + r.status); return r.json(); })
      .then(function (j) {
        var html = j && j[sid];
        if (!html) throw new Error('hq-mega empty');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var d = { l3: {}, fb: {}, t: '' };
        doc.querySelectorAll('[data-hq-l3]').forEach(function (u) { d.l3[u.getAttribute('data-hq-l3')] = squeeze(u.innerHTML); });
        doc.querySelectorAll('[data-hq-fb]').forEach(function (u) { d.fb[u.getAttribute('data-hq-fb')] = squeeze(u.innerHTML); });
        var lb = doc.querySelector('#product_types .custom-select__listbox');
        if (lb) d.t = squeeze(lb.innerHTML);
        data = d;
        try { sessionStorage.setItem(KEY, JSON.stringify(d)); } catch (e) { /* storage full or blocked: keep it for this page only */ }
        wanted.forEach(fill);
        wanted = [];
        return d;
      })
      .catch(function () { pending = null; return null; });   /* try again on the next open */
    return pending;
  }

  function fill(el) {
    if (!data || !el) return;
    if (el === cs) { fillTypes(); return; }
    el.querySelectorAll('[data-hq-empty]').forEach(function (box) {
      var k = box.getAttribute('data-hq-l3'), h = k ? data.l3[k] : data.fb[box.getAttribute('data-hq-fb')];
      if (h == null) return;
      box.innerHTML = h;
      box.removeAttribute('data-hq-empty');
    });
  }
  function fillTypes() {
    if (!data || !data.t || !csEmpty) return;
    var lb = cs.querySelector('.custom-select__listbox');
    var keep = lb.querySelector('[aria-selected="true"]');
    lb.innerHTML = data.t;
    csEmpty = false;
    if (keep && keep.id && keep.id !== 'product_types-opt-default') {   /* a category was already chosen: keep it chosen */
      var now = document.getElementById(keep.id);
      if (now) { lb.querySelectorAll('[aria-selected="true"]').forEach(function (o) { o.setAttribute('aria-selected', 'false'); }); now.setAttribute('aria-selected', 'true'); }
    }
    cs.options = cs.querySelectorAll('.custom-select__option');                      /* custom-select.js type-ahead list */
    cs.selectedOption = cs.querySelector('[aria-selected="true"]') || lb.firstElementChild;
  }
  function want(el) {
    if (!el) return;
    if (data) { fill(el); return; }
    if (wanted.indexOf(el) < 0) wanted.push(el);
    load();
  }

  if (nav) {
    var l1s = nav.querySelectorAll('.main-nav > li');
    l1s.forEach(function (li) {
      if (!li.querySelector('[data-hq-empty]')) return;
      var go = function () { want(li); };
      li.addEventListener('pointerenter', go);
      li.addEventListener('pointerover', go);          /* also when the page opens under a resting mouse */
      li.addEventListener('focusin', go);
      li.addEventListener('click', go, true);          /* phone drawer: before the theme opens the panel */
      li.addEventListener('touchstart', go, { passive: true, capture: true });
    });
    var tog = nav.querySelector('.main-menu__toggle');   /* phone: start loading as soon as the drawer opens */
    if (tog) { tog.addEventListener('click', function () { load(); }); tog.addEventListener('touchstart', function () { load(); }, { passive: true }); }
    var list = nav.querySelector('.main-nav');
    if (list) list.addEventListener('pointerenter', function () { load(); });
  }
  if (csEmpty) {
    var goT = function () { want(cs); };
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) { cs.addEventListener(ev, goT, ev === 'touchstart' ? { passive: true, capture: true } : true); });
    cs.addEventListener('mousedown', goT, true);
    cs.addEventListener('keydown', goT, true);
  }
})();

/* ---- 12.61 Filter button count "Filter & Sort (2)" (brief UI_Brief_Mobile_Collection_Toolbar_2026-10-24) ----
   snippets/products-toolbar.liquid prints the count when the page loads; the theme's facet-filters.js re-renders only the
   filter form (#facets) and the results when a filter changes, not the toolbar, so the count is recalculated here from
   the form: ticked filter values + 1 for a price range in use. */
(function () {
  var btn = document.querySelector('.products-toolbar__filter-btn');
  if (!btn) return;
  function count() {
    var f = document.getElementById('facets');
    if (!f) return null;
    var n = f.querySelectorAll('input[type="checkbox"][name^="filter."]:checked, input[type="radio"][name^="filter."]:checked').length;
    var price = [].some.call(f.querySelectorAll('input[name^="filter.v.price."]'), function (i) { return i.value !== ''; });
    return n + (price ? 1 : 0);
  }
  function update() {
    var n = count();
    if (n === null) return;
    var s = btn.querySelector('.hq-filter-count');
    if (!s) { s = document.createElement('span'); s.className = 'hq-filter-count'; btn.insertBefore(s, btn.querySelector('svg')); }
    var t = n ? '(' + n + ')' : '';
    if (s.textContent !== t) s.textContent = t;
  }
  var t = null;
  function later() { clearTimeout(t); t = setTimeout(update, 60); }
  var form = document.getElementById('facets');
  if (form) {
    form.addEventListener('change', later);
    if ('MutationObserver' in window) new MutationObserver(later).observe(form, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
})();

/* HOSPEQ 12.63: phones (below 769 px) always get the default grid layout (12.33 shows it as list rows), and the
   list/grid icons are hidden there (hq-ui.css 12.63). A list/grid choice saved on a wider screen (localStorage
   cc-products-layout, theme products-toolbar.js) is not changed: it is used again when the page is wider. */
(function () {
  if (!window.matchMedia) return;
  var mq = window.matchMedia('(max-width: 768.98px)');
  function saved() { try { return /list/.test(localStorage.getItem('cc-products-layout') || '') ? 'list' : 'grid'; } catch (e) { return 'grid'; } }
  function apply() {
    var g = document.querySelector('.main-products-grid');
    if (!g || !g.hasAttribute('data-layout')) return;
    var want = mq.matches ? 'grid' : saved();
    if (g.getAttribute('data-layout') !== want) g.setAttribute('data-layout', want);
    var r = document.getElementById(want + '-layout-opt');
    if (r && !r.checked) r.checked = true;
  }
  function phoneOnly() { if (mq.matches) apply(); }
  if ('MutationObserver' in window) new MutationObserver(phoneOnly).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['data-layout'] });
  if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', phoneOnly); else phoneOnly();
})();
